import script from "./TimeExpired.vue?vue&type=script&setup=true&lang=js"
export * from "./TimeExpired.vue?vue&type=script&setup=true&lang=js"

import "./TimeExpired.vue?vue&type=style&index=0&id=63e32ff9&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63e32ff9"]])

export default __exports__